import {
  DefaultService
} from './DefaultService'

export default class FormaRecebimentoService extends DefaultService {
  constructor(http, router, env) {
      super(http, router, env)
  }

  findAll(column, order, page, limit, situacao, ...params) {
      return this._http.get(encodeURI(`${this._env}/vendas/forma-recebimento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
          return res.body;
      }, err => {
          this.verifyError(err);
          throw new Error('Problems while jobs are loading');
      });
  }

  updateSituacao(formaRecebimento) {
      return this._http.post(`${this._env}/vendas/forma-recebimento/updatesituacao`, formaRecebimento, this._headers).then(res => {
          return res.body;
      }, err => {
          this.verifyError(err);
          throw err;
      });
  }
  
  save(form) {
      return this._http.post(`${this._env}/vendas/forma-recebimento`, form, this._headers).then(res => {
          return res.body;
      }, err => {
          this.verifyError(err);
          throw err;
      });
  }


  find(id) {
      return this._http.get(`${this._env}/vendas/forma-recebimento/${id}.json`, this._headers).then(res => {
          return res.body;
      }, err => {
          this.verifyError(err);
          throw new Error('Problems while jobs are loading');
      });
  }
}